import { useEffect, useState } from "react";

// Fetches the End-of-Season Sale state once and exposes it only while the sale is
// genuinely active (server-authoritative: is_active AND within its start/end window),
// so the SALE nav item, homepage promo and /sale offer auto-hide before/after the window.
export function useSeasonSale() {
  const [sale, setSale] = useState(null);

  useEffect(() => {
    let alive = true;
    const base = process.env.REACT_APP_BACKEND_URL;
    fetch(`${base}/api/season-sale`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive && d) setSale(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return {
    sale,
    isActive: !!sale?.is_active,
    headline: sale?.headline || "",
    endsAt: sale?.ends_at || null,
  };
}
